import React from 'react';

import { GeneratingStar } from '../generating-star';

export const EmptyConvos = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full mt-40 gap-2">
      <GeneratingStar className="size-8" variant="disabled" />
      <div className="text-subtlest text-sm w-96 text-center leading-5">{children}</div>
    </div>
  );
};
